// Dialog functionality for handling backdrop clicks to close native dialog elements

function setupDialogListeners() {
  document.querySelectorAll("dialog[data-dialog]").forEach((dialog) => {
    // Remove existing listener to avoid duplicates
    dialog.removeEventListener("click", handleDialogClick);
    // Add the event listener
    dialog.addEventListener("click", handleDialogClick);
  });
}

function handleDialogClick(event) {
  if (event.target === event.currentTarget) {
    event.currentTarget.close();
  }
}

// Initialize dialog functionality
export function initializeDialogs() {
  // Set up listeners on page load and Turbo navigation
  document.addEventListener("DOMContentLoaded", setupDialogListeners);
  document.addEventListener("turbo:load", setupDialogListeners);
}
